import { render } from "./SCR020.vue?vue&type=template&id=7bd7b977"
import script from "./SCR020.vue?vue&type=script&lang=ts"
export * from "./SCR020.vue?vue&type=script&lang=ts"
script.render = render

export default script